import { useEffect } from "react";
import { Course } from "../../Scripts/misc";
import { Modal } from "bootstrap";

interface Props {
    course: Course
}

function SignOutModals({course}: Props) {

    const successModalId = "successModal"+course.id
    const notSignedModalId = "notSignedModal"+course.id

    return ( <>

        {/* Sign out succesful modal*/}
    <div className="modal fade" id={successModalId} tabIndex={-1} aria-labelledby="successLabel">
    <div className="modal-dialog">
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title" id="successLabel">Odhlášení z kroužku</h5>
                <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                Úspěšně jste se odhlásili z kroužku {course.name}
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal" onClick={() => {window.location.reload()}}>Ok</button>
            </div>
        </div>
    </div>
</div>

{/* Not signed into course modal modal*/}
<div className="modal fade" id={notSignedModalId} tabIndex={-1} aria-labelledby="signedLabel">
    <div className="modal-dialog">
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title" id="signedLabel">Odhlášení z kroužku</h5>
                <button type="button" className="close" data-bs-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                </button>
            </div>
            <div className="modal-body">
                Nejste na kroužek {course.name} přihlášeni, takže se z něj nemůžete ani odhlásit
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-secondary" data-bs-dismiss="modal">Ok</button>
            </div>
        </div>
    </div>
</div>

    </> );
}

export default SignOutModals;